export const formatUtcToIstNotificationTime = (value) => {
  if (!value) return "";

  try {
    let normalized = value;

    if (typeof normalized === "string") {
      const microSecondsMatch = normalized.match(/^(.*\.\d{3})\d+(Z?)$/);
      if (microSecondsMatch) {
        normalized = `${microSecondsMatch[1]}${microSecondsMatch[2]}`;
      }

      if (!/[zZ]$/.test(normalized) && !/[+-]\d{2}:?\d{2}$/.test(normalized)) {
        normalized = `${normalized}Z`;
      }
    }

    const date = new Date(normalized);
    if (Number.isNaN(date.getTime())) return "";

    const istOffsetMinutes = 5 * 60 + 30;
    const utcTime = date.getTime() + date.getTimezoneOffset() * 60000;
    const istDate = new Date(utcTime + istOffsetMinutes * 60000);

    return istDate.toLocaleString("en-IN", {
      day: "numeric",
      month: "short",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch (e) {
    return "";
  }
};
